const editorLoader = {
  // selected: {
  //   servizio: {
  //     id: '',
  //     label: '',
  //     data: {},
  //   },
  //   formato: {
  //     id: '',
  //     label: '',
  //     data: {},
  //   },
  //   tipo: {
  //     id: '',
  //     label: '',
  //     data: {},
  //   },
  //   templatesCategory: {
  //     id: '',
  //     label: '',
  //     data: {},
  //   },
  //   template: {
  //     id: '',
  //     label: '',
  //     data: {},
  //   },
  // },
  requiresFuneral: true,
  createNew: false,
  rendered: {
    formatsByTipoId: '',
  },
  existingCanvases: {},
  formats: {},
  templates: {},
  templatesCategories: {},
  defaultFormats: {},
  poppers: {},
  newFormatOrientation: 'h',
  newFormatRelation: {},
  defaultDPI: 300,
  sourceDPI: 72,
};

export default editorLoader;
